import styled from 'styled-components';
import { Button } from '@material-dev/thread';

const IconButton = styled(Button).attrs({
  variant: 'icon'
})`
  width: ${props => props.iconSize || '24px'};
  height: ${props => props.iconSize || '24px'};
  min-width: ${props => props.iconSize || '24px'};
  padding: 0;
  background-color: transparent !important;

  i {
    font-size: ${props => props.iconSize || '24px'} !important;
  }
`;

export default IconButton;



// WEBPACK FOOTER //
// ./src/app/admin/components/IconButton/index.js